import { Injectable } from '@angular/core';
import { CommonService } from 'src/@services/common.service';
import { EndPoints } from 'src/@shared/enum';
import type { IdParam, JsonRecord } from './types/api-payloads.types';

@Injectable({
  providedIn: 'root',
})
export class CommonPagesOrgService {
  constructor(private _cS: CommonService) {}

  getInvestmentLiabilitie() {
    return this._cS.API_GET(EndPoints.GetInvestmentLiabilitie, false);
  }

  getOperatorSites() {
    return this._cS.API_GET(EndPoints.GetAllOperatorSites);
  }

  GetSiteByAccount(agencyType = 0) {
    return this._cS.API_POST(
      EndPoints.GetSiteByAccount + `?agencyType=${agencyType}`
    );
  }
  getAllSuppliersDropdown() {
    return this._cS.API_GET(EndPoints.GetAllSuppliersDropdown, false);
  }

  GetAllAccountTypesDropdown(accountType: number) {
    return this._cS.API_GET(
      EndPoints.GetAllAccountTypesDropdown + `?typeEnum=${accountType}`,
      false
    );
  }

  GetAllSiteTypesDropdown(siteTab: number) {
    return this._cS.API_GET(
      EndPoints.GetAllSiteTypesDropdown + `?accountAgencyType=${siteTab}`,
      false
    );
  }

  createAgency(agencyBody: JsonRecord) {
    return this._cS.API_POST(EndPoints.AddAgency, agencyBody);
  }
  updateAgency(agencyBody: JsonRecord) {
    return this._cS.API_POST(EndPoints.UpdateAgency, agencyBody);
  }

  createAccount(accountBody: JsonRecord) {
    return this._cS.API_POST(EndPoints.AddAccount, accountBody);
  }
  updateAccount(accountBody: JsonRecord) {
    return this._cS.API_POST(EndPoints.UpdateAccount, accountBody);
  }

  fileContractUpload(userBody: FormData) {
    return this._cS.API_POSTFileUpload(EndPoints.uploadContractFile, userBody);
  }

  createSite(siteBody: JsonRecord) {
    return this._cS.API_POST(EndPoints.AddSite, siteBody);
  }

  updateSite(siteBody: JsonRecord) {
    return this._cS.API_POST(EndPoints.UpdateSite, siteBody);
  }

  getGenericPopulateRecords(type: IdParam) {
    return this._cS.API_GET(EndPoints.GenericPopulateRecords + `/${type}`);
  }
  getAllSiteTypes() {
    return this._cS.API_GET(EndPoints.GetAllSiteTypes);
  }

  AddAccountType(accountType: JsonRecord) {
    return this._cS.API_POST(EndPoints.AddAccountType, accountType);
  }
  UpdateAccountType(accountType: JsonRecord) {
    return this._cS.API_POST(EndPoints.UpdateAccountType, accountType);
  }

  AddResouce(resource: JsonRecord) {
    return this._cS.API_POST(EndPoints.AddResource, resource);
  }
  UpdateResource(resource: JsonRecord) {
    return this._cS.API_POST(EndPoints.UpdateResource, resource);
  }

  updateNonAlcDetails(nonAlcDetails: JsonRecord) {
    return this._cS.API_POST(EndPoints.UpdateNonAlcDetails, nonAlcDetails);
  }

  getQBOCustomers() {
    return this._cS.API_GET(EndPoints.GetInvestorForSite);
  }

  getNonAlcTransactionFilters(siteId: string) {
    return this._cS.API_GET(
      EndPoints.GetNonAlcTransactionFilters + `?siteId=${siteId}`,
      false
    );
  }

  exportNonAlcTransactions(
    siteId: string,
    page: number,
    pageSize: number,
    sortBy: string,
    sortField: string,
    transactionType: string
  ) {
    const hd = this._cS.GetAuthorizationHeader();
    return this._cS.API_GET(
      EndPoints.NonAlcTransactionsExport +
        `?siteId=${siteId}&page=${page}&pageSize=${pageSize}&sortby=${sortBy}&sortField=${sortField}&transactionType=${transactionType}`,
      false,
      {
        responseType: 'blob',
        headers: hd,
      }
    );
  }

  getSupplierById(id: IdParam) {
    return this._cS.API_GET(EndPoints.GetSupplierById + `?Id=${id}`, false);
  }
}
